<div class="l-main" role="main">
	<div class="l-container">

		<div class="l-content">


			<div class="panel-pane bg-transparent align-center">
				<ul class="list--pipe">
					<li><a href="">Visit the UC Davis directory</a></li>
				</ul>
			</div>

			<div class="panel-pane box">
        
            <!-- ********** Main content ********** -->                                                  
                                                                                             
						<div id="main_section">                                                          
                                                                                             
							<!-- Center column (primary content) -->                                       
                                                                                             
							<div id="center_column">                                                       
                                                                                             
								<!-- <div id="center_column_inner_wrap"> -->  
							     
								 <div stytle="width: 1440px; height: 2050px">								  
							     <embed src ="assets/pdf/abr.pdf" type="application/pdf" width="1440px" height="2100px" />	
							     </div>
							     
							    <!-- </div>  -->
							    
							</div>     
										
						</div>			


			</div>  <!-- panel-pane box -->

		</div>
		<!--end .l-content-->

	</div>
</div>

<!--End role=main-->
<p class="privacy">
	<strong>Privacy Notice:</strong> This campus directory is the property
	of <a href="https://www.ucdavis.edu"><font size="3" color="navy">University
			of California, Davis.</font> </a> To protect the privacy of individuals listed
	herein, in accordance with the State of California Information
	Practices Act, this directory may not be used, rented, distributed, or
	sold for commercial purposes.
</p>